const AcceptProjectInvitation = () => import("@/views/guest/AcceptProjectInvitation");
import GuestLayout from "@/layouts/GuestLayout";


const routes = [
    {
        path: '/project/accept-invitation',
        name: 'project.accept-invitation',
        component: AcceptProjectInvitation,
        meta: {
            title: 'Zaproszenie do projektu',
            globalAccess: true,
            layout: {
                component: GuestLayout,
                props: {
                    additionalClass: "auth__box--reset",
                    displayLogo: false,
                }
            }
        }
    }
]

export default routes;